(function($) {

    if($('figure').hasClass('gallery')){
       $('figure a').addClass('lightbox');
    }

    $('.gallery .lightbox').magnificPopup({type: 'image', gallery:{enabled:true} });


})(jQuery);